import { DrawerComponent } from '../initializers/drawer-component';
import { ScrollTopComponent } from '../initializers/scroll-top-component';
import { StickyComponent } from '../initializers/sticky-component';
import { ToggleComponent } from '../initializers/toggle-component';
import { InlineSvg } from 'components/svg';
import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollTop() {
  const { pathname } = useLocation();
  const isFirstRun = useRef(true);

  const pluginsReinitialization = () => {
    setTimeout(() => {
      StickyComponent.reInitialization();
      setTimeout(() => {
        ToggleComponent.reinitialization();
        DrawerComponent.reinitialization();
      }, 70);
    }, 140);
  };

  const scrollTop = () => {
    ScrollTopComponent.goTop();
  };

  const updateHeaderSticky = () => {
    const stickyHeader = document.body.querySelectorAll(`[data-kt-sticky-name="header"]`);
    if (stickyHeader && stickyHeader.length > 0) {
      const sticky = StickyComponent.getInstance(stickyHeader[0] as HTMLElement);
      if (sticky) {
        sticky.update();
      }
    }
  };

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
    } else {
      pluginsReinitialization();
    }

    updateHeaderSticky();
    setTimeout(() => {
      scrollTop();
    }, 0);
  }, [pathname]);

  return (
    <div id="kt_scrolltop" className="scrolltop" data-kt-scrolltop="true">
      <InlineSvg path="/media/icons/duotune/arrows/arr066.svg" />
    </div>
  );
}
